import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { navigateToManual } from "utils/navigator"

/**
 * Help button for a page: opens its user manual (api/manuals/<slug>.md) inside the portal.
 * The slug is the manual's path, e.g. "human-resources/employees".
 */
const useManual = (slug: string) => {
    const navigate = useNavigate()
    const handleOpenManual = useCallback(() => navigateToManual(navigate, slug), [navigate, slug])

    return { handleOpenManual }
}

export default useManual
